module.exports = __webpack_public_path__ + "img/thumbnail_GreaterRhea_f_normal.bdb32308.png";